import { BACKEND_APIS } from '@constants'
import { Box } from '@mui/material'
import { filterPanelGridSx } from '@components'
import { batch } from '@preact/signals-react'
import { offices, officesOptions, reports } from '@signals'

import ReportsAutocomplete from 'Pages/@PageWrapper/Actions/Reports'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'


export default function NotificationsFilter() {

	const [ searchParams ] = useSearchParams()

	useEffect(() => {
		offices.value = Number(searchParams.get("idOfficePickup")) || null
		return () => batch(() => {
			offices.value = null
			officesOptions.value = []
		})
	}, [])

	return <Box data-tour-id="tour-notif-filter" sx={filterPanelGridSx(4)}>
		<Box>
			<ReportsAutocomplete
				error={ !reports.value && "Must select a report in order to view notifications!"}
				filters={{
					fromAlertNotification: true,
				}}
			/>
		</Box>
		<Box>
			{ !!reports.value && <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
				sx={{ display: "flex", alignItems: "start", justifyContent: "center" }}
				multiple={false}
				value={offices.value}
				urlAjax={`${BACKEND_APIS.EXECUTION_INFO}/offices`}
				onChange={e => offices.value = e.target.value}
				filters={{
					idReportExecution: reports.value,
					selected: offices.value
				}}
				onFinishAjax={options => {
					offices.value = options.filter(({ selected }) => selected)[0]?.value || options[0].value
				}}
				label="Select a office"
				error={ !offices.value && "Must select an office in order to view notifications!"}
			/>}
		</Box>
	</Box>
}